// src/Components/Modals/ForgetPasswordModal.jsx
import React from "react";
import "./login.css";
import ForgetPassword from "../Forgetpassword/Forgetpassword";

const ForgetPasswordModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>×</button>
                <ForgetPassword />
            </div>
        </div>
    );
};

export default ForgetPasswordModal;
